// [NEW FILE] PM-10: automatic reminders without a backend scheduler.
// The backend sends the reminders of every active reminder rule when POST /reminders/dispatch is called, and it never
// sends the same reminder twice on one day (each notification has a per-day key). It has no timer of its own, so the
// app calls it once a day, in the background, as soon as someone allowed to manage reminders (HR) opens PMS.
// Employees who have not set or submitted their goals then get the reminder of the "Goal setting" rule automatically.
import { useEffect } from "react";
import { can, ORG_SCOPES } from "../services/core";
import { dispatchReminders } from "../services/reminderApi";
import { BACKEND } from "../config/backendFeatures";

export const AUTO_REMINDER_KEY = "pms_auto_reminders_last_run";
const today = () => new Date().toISOString().slice(0, 10);

export function lastAutoReminderRun() {
  try { return localStorage.getItem(AUTO_REMINDER_KEY) || ""; } catch { return ""; }
}

export default function useAutoReminders(profile) {
  // [NEW] With REACT_APP_BACKEND_REMINDER_SCHEDULER=true the backend sends reminders on its own, so the browser does nothing.
  const allowed = !BACKEND.reminderScheduler && Boolean(profile) && can(profile, "reminder.manage", ORG_SCOPES);
  useEffect(() => {
    if (!allowed || lastAutoReminderRun().startsWith(today())) return;
    try { localStorage.setItem(AUTO_REMINDER_KEY, new Date().toISOString()); } catch { /* storage blocked */ }
    dispatchReminders("Automatic daily reminders").catch(() => {
      try { localStorage.removeItem(AUTO_REMINDER_KEY); } catch { /* storage blocked */ }
    });
  }, [allowed]);
}
